
import React from 'react';
import { Instagram, Youtube, Facebook, Disc } from 'lucide-react';
import Logo from './Logo';

interface FooterProps {
  onOpenLegal: () => void;
}

const Footer: React.FC<FooterProps> = ({ onOpenLegal }) => {
  return (
    <footer className="py-20 border-t border-white/5">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-12 md:space-y-0">
          <div className="flex flex-col items-center md:items-start">
            <Logo className="w-40 mb-6" />
            <p className="text-white/40 max-w-xs text-sm font-light text-center md:text-left">
            Clubs | Mariages | Évènements Privés | Festivals
            </p>
          </div>

          <div className="flex space-x-6">
            <a href="https://www.instagram.com/djsaffmusic" target="_blank" rel="noopener noreferrer" className="w-12 h-12 glass rounded-full flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/50 transition-all">
              <Instagram size={20} />
            </a>
            <a href="https://www.facebook.com/djsaffmusic" target="_blank" rel="noopener noreferrer" className="w-12 h-12 glass rounded-full flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/50 transition-all">
              <Facebook size={20} />
            </a>
            <a href="https://www.youtube.com/@djsaffmusic" target="_blank" rel="noopener noreferrer" className="w-12 h-12 glass rounded-full flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/50 transition-all">
              <Youtube size={20} />
            </a>
            <a href="https://www.mixcloud.com/djsaffmusic/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 glass rounded-full flex items-center justify-center text-white/60 hover:text-gold hover:border-gold/50 transition-all">
              <Disc size={20} />
            </a>
          </div>

          <div className="text-center md:text-right">
            <p className="text-xs font-bold tracking-widest uppercase text-white/40 mb-2">Zone d'Activité</p>
            <p className="text-sm">Sud Est de la France & France entière</p>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex flex-col md:flex-row md:space-x-8 items-center text-center md:text-left">
            <p className="text-[10px] text-white/20 uppercase tracking-[0.2em]">
              © 2026 DJ SAFF. All Rights Reserved.
            </p>
          </div>
          <div className="flex space-x-6 text-[10px] text-white/20 uppercase tracking-[0.2em]">
            <button onClick={onOpenLegal} className="hover:text-gold transition-colors">Mentions Légales</button>
            <button className="hover:text-gold transition-colors">Confidentialité</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
